port module Main exposing (main)

import Browser
import Html exposing (..)
import Html.Attributes as HA
import Html.Events as HE



-- MODEL


type alias Model =
    { clipboard : String }


type alias Flags =
    {}


init : Flags -> ( Model, Cmd Msg )
init flags =
    ( { clipboard = "" }
    , Cmd.none
    )



-- MESSAGES


type Msg
    = RequestClipboard
    | ClipboardReceived String



-- PORTS


port requestClipboard : () -> Cmd msg


port clipboardReceived : (String -> msg) -> Sub msg



-- UPDATE


update : Msg -> Model -> ( Model, Cmd Msg )
update msg model =
    case msg of
        RequestClipboard ->
            ( model, requestClipboard () )

        ClipboardReceived text ->
            ( { model | clipboard = text }, Cmd.none )



-- VIEW


view : Model -> Html Msg
view model =
    div
        [ HA.class "flex flex-col items-center min-h-screen text-center px-6 py-12 leading-relaxed" ]
        [ h1
            [ HA.class "text-4xl font-medium tracking-wide mb-8" ]
            [ text "The Once Over" ]
        , p
            [ HA.class "text-base mb-10" ]
            [ text "A nicer way to read" ]
        , div
            [ HA.class "my-8" ]
            [ div
                [ HA.class "w-10 h-10 mx-auto" ]
                [ img [ HA.src "/logo.svg" ] [] ]
            ]
        , hr [ HA.class "w-full mb-8" ] []
        , h1
            [ HA.class "text-3xl font-medium tracking-wide mb-8 uppercase" ]
            [ text "Contents" ]
        , div
            [ HA.class "max-w-lg space-y-8 text-left" ]
            [ tocItem "fa-solid fa-pen" "Input Text" "Write or paste your own words" "placeholder"
            , tocItem "fa-solid fa-book" "Browse the Library" "Discover beautifully formatted classics" "placeholder"
            ]
        ]


tocItem : String -> String -> String -> String -> Html msg
tocItem iconClass title author details =
    div [ HA.class "grid grid-cols-[2rem_1fr] gap-4" ]
        [ -- Left column: icon
          div [ HA.class "text-xl text-ink/80 text-right pt-[3px]" ]
            [ i [ HA.class iconClass ] [] ]
        , -- Right column: title and content
          div []
            [ div [ HA.class "border-b border-dotted border-ink/40 pb-[3px] flex justify-between items-baseline" ]
                [ span [ HA.class "text-lg font-medium" ] [ text title ] ]
            , div [ HA.class "pl-1 pt-1 text-base italic text-ink/90" ] [ text author ]
            , if details /= "" then
                div [ HA.class "pl-1 text-sm text-ink/80" ] [ text details ]

              else
                text ""
            ]
        ]


pasteView : Model -> Html Msg
pasteView model =
    div []
        [ button [ HE.onClick RequestClipboard ] [ text "Paste Clipboard" ]
        , div [] [ text ("Clipboard: " ++ model.clipboard) ]
        ]



-- SUBSCRIPTIONS


subscriptions : Model -> Sub Msg
subscriptions _ =
    clipboardReceived ClipboardReceived



-- MAIN


main : Program Flags Model Msg
main =
    Browser.element
        { init = init
        , update = update
        , subscriptions = subscriptions
        , view = view
        }
